import { CriteriaQuery } from './criteria.model';
import {
  CreateFn,
  FindAllFn,
  FindByKeyFn,
  LoadForm,
  LookUpFn,
  ModifyFn,
  //PatchFn,
    
} from './http-provider.model';

export declare interface BaseFpxDataService<T> {
  findByKey(payload: T,httpOption?: Map<any, Map<string, any>>): FindByKeyFn<T>;
  findAll(criteriaQuery: CriteriaQuery,httpOption?: Map<keyof any, Map<string, any>>): FindAllFn<T>;
  create(payload: T,httpOption?: Map<keyof any, Map<string, any>>): CreateFn<T>;
  lookup(key: unknown,httpOption?: Map<keyof any, Map<string, any>>,criteriaQuery?: CriteriaQuery): LookUpFn<T>;
  modify(payload: T,httpOption?: Map<keyof any, Map<string, any>>): ModifyFn<T>;
  loadForm?(payload:any,httpOption?: Map<keyof any, Map<string, any>>) : LoadForm<any>;
  //patch?(payload:any,httpOption?: Map<keyof any, Map<string, any>>) : PatchFn<any>;
}

export interface FpxIHttpOption {
  headerParam : Map<string,any>,
  querryParam : Map<string,any>,
  pathParam : Map<string,any>
}